var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6663 10C11.6663 8.15909 13.1587 6.66671 14.9997 6.66671H24.9997C26.8406 6.66671 28.333 8.15909 28.333 10V30C28.333 31.841 26.8406 33.3334 24.9997 33.3334H14.9997C13.1587 33.3334 11.6663 31.841 11.6663 30V10ZM14.9997 3.33337C11.3178 3.33337 8.33301 6.31814 8.33301 10V30C8.33301 33.6819 11.3178 36.6667 14.9997 36.6667H24.9997C28.6816 36.6667 31.6663 33.6819 31.6663 30V10C31.6663 6.31814 28.6816 3.33337 24.9997 3.33337H14.9997ZM19.9997 30C20.9201 30 21.6663 29.2538 21.6663 28.3334C21.6663 27.4129 20.9201 26.6667 19.9997 26.6667C19.0792 26.6667 18.333 27.4129 18.333 28.3334C18.333 29.2538 19.0792 30 19.9997 30Z",
    fill: "#E87663"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobile-icon.96307778436bf9962fe15a7eada0a185.svg";
export { ForwardRef as ReactComponent };